import { PROXY } from "modules/ebiForms/common";
import { IEbiFormSection } from "modules/ebiForms/typings";

/**
 * Reprezentacja przedsiębiorcy (B7, B8): stroną jest przedsiębiorca (albo rolnik) opisany w dalszej sekcji formularza
 * (`businessSection`), więc — inaczej niż `representationSection()` — bez osobnych pól mocodawcy, które powielałyby
 * dane firmy. Kody i wartości jak we wspólnym bloku (`wImieniu`, `pelnomocnik`, `pelnomocnictwoZwolnione`), dzięki
 * czemu `proxyAttachments()` działa bez zmian (pełnomocnictwo + 17 zł).
 */
export const businessRepresentationSection = (
  options: { party?: string; self?: string } = {},
): IEbiFormSection => {
  const party = options.party ?? "przedsiębiorcy";
  const self = options.self ?? "jako przedsiębiorca albo osoba uprawniona do jego reprezentacji (np. wspólnik, członek zarządu według KRS)";

  return {
    code: "reprezentacja",
    title: "Podstawa działania",
    fields: [
      {
        code: "wImieniu",
        type: "radio",
        label: "Składam wniosek",
        required: true,
        defaultValue: "wlasnym",
        options: [
          { value: "wlasnym", label: `osobiście — ${self}` },
          { value: "pelnomocnik", label: `jako pełnomocnik ${party} (art. 33 KPA)` },
        ],
      },
      {
        code: "pelnomocnictwoZwolnione",
        type: "checkbox",
        label:
          "Jestem małżonkiem, wstępnym, zstępnym lub rodzeństwem mocodawcy — pełnomocnictwo jest zwolnione z opłaty skarbowej",
        visibleWhen: PROXY,
      },
    ],
  };
};
